const STORAGE_PREFIX = 'browse_as_collector:';
const LEGACY_PREFIX = 'browse_as_supervisor';

function userIdFrom(user) {
  if (!user || typeof user !== 'object') return null;
  const id = user.id != null ? user.id : user.user_id;
  return id == null || id === '' ? null : String(id);
}

function browseStorageKey(userId) {
  return userId ? STORAGE_PREFIX + userId : null;
}

function readStoredAsCollector(userId) {
  if (!userId) return false;
  try {
    return localStorage.getItem(browseStorageKey(userId)) === '1';
  } catch (e) {
    return false;
  }
}

function writeStoredAsCollector(userId, asCollector) {
  if (!userId) return;
  try {
    localStorage.setItem(browseStorageKey(userId), asCollector ? '1' : '0');
  } catch (e) {}
}

function clearUserBrowseMode(userId) {
  try {
    const key = browseStorageKey(userId);
    if (key) localStorage.removeItem(key);
  } catch (e) {}
}

function clearBrowseModeStorage() {
  try {
    const keys = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k === LEGACY_PREFIX || (k && (k.indexOf(LEGACY_PREFIX) === 0 || k.indexOf(STORAGE_PREFIX) === 0))) {
        keys.push(k);
      }
    }
    keys.forEach(function (k) { localStorage.removeItem(k); });
  } catch (e) {}
}

function readUser(rootState) {
  const user = rootState && rootState.auth && rootState.auth.user;
  if (user && typeof user === 'object') return user;
  try {
    const auth = JSON.parse(localStorage.getItem('authentication_key') || 'null');
    return (auth && auth.user) || null;
  } catch (e) {
    return null;
  }
}

function userCanToggleBrowseMode(user) {
  if (!user || typeof user !== 'object') return false;
  return Number(user.can_browse_as_collector) === 1 || Number(user.allow_browse_as_collector) === 1;
}

export default {
  namespaced: true,
  state: {
    asCollector: false,
    userId: null
  },
  getters: {
    asCollector: s => s.asCollector,
    asSupervisor: s => !s.asCollector,
    canToggle: (s, g, rs) => userCanToggleBrowseMode(readUser(rs))
  },
  mutations: {
    hydrate(s, payload) {
      const user = payload && payload.user ? payload.user : payload;
      const reset = payload && payload.reset;
      const id = userIdFrom(user);
      s.userId = id;
      if (reset) {
        s.asCollector = false;
        writeStoredAsCollector(id, false);
        return;
      }
      const stored = readStoredAsCollector(id);
      const hasFlag = user && (user.can_browse_as_collector !== undefined || user.allow_browse_as_collector !== undefined);
      if (hasFlag && !userCanToggleBrowseMode(user)) {
        s.asCollector = false;
        writeStoredAsCollector(id, false);
        return;
      }
      s.asCollector = stored;
    },
    clear(s) {
      clearUserBrowseMode(s.userId);
      s.asCollector = false;
      s.userId = null;
    },
    toggle(s) {
      s.asCollector = !s.asCollector;
      writeStoredAsCollector(s.userId, s.asCollector);
    }
  },
  actions: {
    hydrate({commit, rootState}) {
      commit('hydrate', {user: readUser(rootState), reset: false});
    },
    resetForLogin({commit}, user) {
      commit('hydrate', {user: user, reset: true});
    },
    clear({commit}) {
      commit('clear');
    }
  }
};

export {clearBrowseModeStorage, userCanToggleBrowseMode};
